module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2a",
    attrs: {
      "id": "ack"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _c('a', {
    attrs: {
      "href": "#/Contents#rack"
    }
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', [_vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HILE IT")]), _vm._v("’"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S IMPOSSIBLE")]), _vm._v(" to adequately thank everyone who has contributed to our 14th edition "), _c('i', [_vm._v("Solar Living Sourcebook")]), _vm._v(" and to Real Goods’ extraordinary 36-year odyssey in general, several people stand out above the crowd. In the 36 years and 14 editions of this "), _c('i', [_vm._v("Sourcebook")]), _vm._v(", more than 700,000 copies have been sold in 44 English-speaking countries. For this edition, thanks go first to Alan Berolzheimer, our managing editor, who toiled tirelessly over many months to manage the new chapters as well as the old while putting his all into the entire book. His masterful pen and mind often performed miracles of weaving straw draft copy into gold nuggets of final prose. Hearty thanks go to several people who helped get our chapters new to this 14th edition launched: to Daniel Lerch for his revision of the Relocalization chapter, to David Arkin and Amanda Knowles for a thorough rewrite of Land and Shelter, to Brad Lancaster for generous contributions to the updated Water Development chapter, and to Art Ludwig for revising Composting Toilets and Greywater Systems. Special thanks to Rachel Kaplan for her work on the brand new Urban Homesteading chapter. Thanks to Bob Ramlow, who has helped tremendously on the last several "), _c('i', [_vm._v("Sourcebooks")]), _vm._v(" with the Solar Hot Water chapter. I also want to thank Benjamin Fahrer for his work on the Permaculture section and to Jim Fullmer for his updates on Biodynamics. Raphael Schiffman helped us tremendously with much needed updating to "), _c('span', {
    attrs: {
      "href": "#/Chapter03#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapters 3")]), _vm._v(" and "), _c('span', {
    attrs: {
      "href": "#/Chapter04#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")]), _vm._v(", really the renewable energy heart of this book. Of course I thank both Steve Heckeroth and Dave Blume for their passionate defense of both electric vehicles and alcohol as a vehicle fuel. The book wouldn’t have been complete without the final “back to the land” Natural Burial updates from Cynthia Beal. And thanks to Lindsay Wood for her last-minute updates about efficient lighting and LEDs. Thanks also go to Tony Novelli for helping out with the resource list and with "), _c('a', {
    attrs: {
      "href": "#/Chapter02#ch2"
    }
  }, [_vm._v("Chapter 2")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("Thanks also to the folks at New Society Publishers for doing such an amazing job of distribution with our 30th anniversary edition and for encouraging us to continue to keep the "), _c('i', [_vm._v("Sourcebook")]), _vm._v(" updated. And for "), _c('i', [_vm._v("Sourcebook")]), _vm._v("s past, there are many to thank who have nurtured the book over the years and some of whose work still remains current to this day. I especially thank Doug Pratt, Stephen Morris, and Jeff Oldham for their inspiration and dedication to Real Goods and the entire "), _c('i', [_vm._v("Sourcebook")]), _vm._v(" project over the years. Thanks also go of course to Real Goods’ current CEO, Kam Mofid, without whose encouragement this book would not have been possible, and to Melissa Watson, who has taken over management from me of the retail store and our webstore ("), _c('a', {
    attrs: {
      "href": "http://realgoods.com",
      "target": "_blank"
    }
  }, [_vm._v("realgoods.com")]), _vm._v(") so that I could work on this "), _c('i', [_vm._v("Sourcebook")]), _vm._v(". And on a personal note, I thank my wife, Nantzy, for her frequent insight and inspiration for this and most all of my writing, and my children, Sara, Ashley, and Cy, for their help over the years. Finally, for their unwavering financial support, I thank the original 10,000 Real Goods shareowners from the 1990s for directly bringing the Solar Living Center into fruition, and the directors and staff of the Solar Living Institute for nurturing that original vision to the present day.")])]), _vm._v(" "), _c('p', {
    staticClass: "h3a"
  }, [_c('span', [_vm._v("The Nonprofit Real Goods Solar Living Institute")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', [_vm._v("The Solar Living Institute is a 501-C-3 nonprofit organization that promotes inspirational environmental education through hundreds of hands-on workshops; SolFest—an annual renewable energy educational event now in its 16th year with displays and interactive demonstrations at our solar-powered 12-acre permaculture oasis called the Solar Living Center in Hopland, California; and numerous children’s educational programs. More information about the Institute can be found on "), _c('span', {
    attrs: {
      "href": "#/Appendix#page_413",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("pages 413–18")]), _vm._v(" or at its website ("), _c('a', {
    attrs: {
      "href": "http://solarliving.org",
      "target": "_blank"
    }
  }, [_vm._v("solarliving.org")]), _vm._v(") or by calling 707-472-2450. The Institute has an innovative membership program and encourages tax-deductible donations to further its programs.")])]), _vm._v(" "), _c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_xii"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "height": "457",
      "src": "images/f0xii-01.jpg",
      "width": "457"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8a2ab536","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Acknowledgments.vue
// module id = 69
// module chunks = 0